import { NgModule } from '@angular/core';
import {
  BrowserModule,
  BrowserTransferStateModule,
} from '@angular/platform-browser';
import { NgxMaskModule } from 'ngx-mask';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { EventsModule } from './features/events/events.module';
import { HttpClientModule } from '@angular/common/http';
import { OrderModule } from './features/order/order.module';
import { ContentModule } from './features/content/content.module';
import { RouterModule } from '@angular/router';
import {
  RecaptchaV3Module,
  RECAPTCHA_V3_SITE_KEY,
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
} from 'ng-recaptcha';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserTransferStateModule, // Agregamos esto para habilitar TransferState
    AppRoutingModule,
    HttpClientModule,
    CoreModule,
    EventsModule,
    OrderModule,
    ContentModule,
    RouterModule,
    NgxMaskModule.forRoot(),
    RecaptchaV3Module,
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: '6LfBrywsAAAAAN3076wcRKJEt5FRyTm4inVBmDJ8',
    },
    {
      // v2 challenge key, read by <re-captcha> in the checkout.
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.recaptchaV2SiteKey } as RecaptchaSettings,
    },
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
